import { Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React from 'react';
import { Controller } from 'react-hook-form';

import FieldLabel from './FieldLabel';

function DateField({ label, tooltip, control, name, rules }) {
  return (
    <Stack spacing={1}>
      <FieldLabel label={label} tooltip={tooltip} />
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <DatePicker
            slotProps={{
              textField: {
                placeholder: label,
                error: !!error,
                helperText: error ? error.message : null,
              },
            }}
            {...field}
          />
        )}
      />
    </Stack>
  );
}

export default DateField;
